import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "network-logs-view" }
const _hoisted_2 = { class: "font-weight-medium" }
const _hoisted_3 = { class: "font-weight-medium" }
const _hoisted_4 = {
  key: 1,
  class: "text-grey"
}

import { ref, onMounted, computed } from 'vue'
import { useNetworkLogsStore } from './store'
import { NetworkLogs } from './models/networkLogs'


export default /*@__PURE__*/_defineComponent({
  __name: 'NetworkLogsView',
  setup(__props) {

const networkLogsStore = useNetworkLogsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'ID Origen', key: 'sourceId' },
  { title: 'Tipo Origen', key: 'sourceType' },
  { title: 'Operación', key: 'operation' },
  { title: 'Estado', key: 'status' },
  { title: 'Fecha/Hora', key: 'timestamp' },
  { title: 'Mensaje', key: 'message' },
  { title: 'Código Error', key: 'errorCode' },
  { title: 'Latencia', key: 'latencyMs' },
  { title: 'Notificado', key: 'notificated' },
  { title: 'Creado', key: 'createdAt' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const networkLogsList = computed(() => networkLogsStore.networkLogs)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleDateString('es-ES')
}

const formatDateTime = (date: Date | string) => {
  return new Date(date).toLocaleString('es-ES')
}

const truncateMessage = (message: string) => {
  if (!message) return 'Sin mensaje'
  return message.length > 40 ? message.substring(0, 40) + '...' : message
}

const getSourceTypeColor = (sourceType: string) => {
  switch (sourceType) {
    case 'sensorExtraction':
      return 'blue'
    case 'sensorInjection':
      return 'green'
    case 'deviceExtraction':
      return 'orange'
    default:
      return 'grey'
  }
}

const getSourceTypeLabel = (sourceType: string) => {
  switch (sourceType) {
    case 'sensorExtraction':
      return 'Extracción Sensor'
    case 'sensorInjection':
      return 'Inyección Sensor'
    case 'deviceExtraction':
      return 'Extracción Dispositivo'
    default:
      return sourceType
  }
}

const getOperationColor = (operation: string) => {
  switch (operation) {
    case 'extraction':
      return 'blue'
    case 'injection':
      return 'green'
    default:
      return 'grey'
  }
}

const getOperationLabel = (operation: string) => {
  switch (operation) {
    case 'extraction':
      return 'Extracción'
    case 'injection':
      return 'Inyección'
    default:
      return operation
  }
}

const getStatusColor = (status: string) => {
  switch (status) {
    case 'connected':
      return 'success'
    case 'disconnected':
      return 'error'
    case 'timeout':
      return 'warning'
    case 'error':
      return 'red'
    default:
      return 'grey'
  }
}

const getStatusLabel = (status: string) => {
  switch (status) {
    case 'connected':
      return 'Conectado'
    case 'disconnected':
      return 'Desconectado'
    case 'timeout':
      return 'Timeout'
    case 'error':
      return 'Error'
    default:
      return status
  }
}

const getLatencyColor = (latencyMs: number) => {
  if (latencyMs < 100) return 'success'
  if (latencyMs < 500) return 'warning'
  return 'error'
}

const refreshData = async () => {
  loading.value = true
  try {
    await networkLogsStore.getNetworkLogs()
  } finally {
    loading.value = false
  }
}

const addItem = () => {
  // Implementar lógica para agregar log de red
  console.log('Add new network log')
}

const editItem = (item: NetworkLogs) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: NetworkLogs) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_container, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => _cache[0] || (_cache[0] = [
                _createElementVNode("h1", null, "Logs de Red", -1),
                _createElementVNode("p", null, "Gestión de logs de eventos de red del sistema", -1)
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_row, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, { cols: "12" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_data_table, {
                  headers: headers,
                  items: networkLogsList.value,
                  loading: loading.value,
                  class: "elevation-1",
                  "items-per-page": 25,
                  "sort-by": [{ key: 'timestamp', order: 'desc' }]
                }, {
                  top: _withCtx(() => [
                    _createVNode(_component_v_toolbar, { flat: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar_title, null, {
                          default: _withCtx(() => _cache[1] || (_cache[1] = [
                            _createTextVNode("Lista de Logs de Red")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_divider, {
                          class: "mx-4",
                          inset: "",
                          vertical: ""
                        }),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "primary",
                          onClick: refreshData
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode("mdi-refresh")
                              ])),
                              _: 1
                            }),
                            _cache[3] || (_cache[3] = _createTextVNode(" Actualizar "))
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "success",
                          class: "ml-2",
                          onClick: addItem
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { left: "" }, {
                              default: _withCtx(() => _cache[4] || (_cache[4] = [
                                _createTextVNode("mdi-plus")
                              ])),
                              _: 1
                            }),
                            _cache[5] || (_cache[5] = _createTextVNode(" Agregar Log "))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  "item.sourceType": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getSourceTypeColor(item.sourceType),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getSourceTypeLabel(item.sourceType)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.operation": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getOperationColor(item.operation),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getOperationLabel(item.operation)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.status": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getStatusColor(item.status),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(getStatusLabel(item.status)), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.timestamp": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(formatDateTime(item.timestamp)), 1)
                  ]),
                  "item.message": _withCtx(({ item }) => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(truncateMessage(item.message)), 1)
                  ]),
                  "item.errorCode": _withCtx(({ item }) => [
                    (item.errorCode)
                      ? (_openBlock(), _createBlock(_component_v_chip, {
                          key: 0,
                          color: "red",
                          variant: "outlined",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.errorCode), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
                  ]),
                  "item.latencyMs": _withCtx(({ item }) => [
                    _createVNode(_component_v_chip, {
                      color: getLatencyColor(item.latencyMs),
                      variant: "outlined",
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.latencyMs) + " ms ", 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.notificated": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      color: item.notificated ? 'warning' : 'success',
                      small: ""
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.notificated ? 'mdi-bell' : 'mdi-bell-off'), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  "item.createdAt": _withCtx(({ item }) => [
                    _createTextVNode(_toDisplayString(formatDate(item.createdAt)), 1)
                  ]),
                  "item.actions": _withCtx(({ item }) => [
                    _createVNode(_component_v_icon, {
                      small: "",
                      class: "mr-2",
                      onClick: ($event: any) => (editItem(item))
                    }, {
                      default: _withCtx(() => _cache[6] || (_cache[6] = [
                        _createTextVNode(" mdi-pencil ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_v_icon, {
                      small: "",
                      onClick: ($event: any) => (deleteItem(item))
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" mdi-delete ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["items", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})